import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 13,
	viewBox: "0 0 15 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.92021 0L6.75425 0.143273L0.921796 5.77186L0.558594 6.14028L0.922857 6.5087L5.69486 11.1139L6.07662 11.4649L6.45838 11.1134L12.2908 5.48481L12.4393 5.32362V0H6.92021ZM7.36771 1.02338H11.3773V4.89329L6.07503 10.0102L2.06496 6.14028L7.36718 1.02338H7.36771ZM12.9679 1.53507V2.55845H13.4981V6.7318L8.46103 11.5611L7.79825 10.9215L7.05276 11.641L8.0798 12.649L8.46156 13L8.82742 12.6485L14.4101 7.32229L14.5586 7.16366V1.53507H12.9679ZM9.78659 2.04676C9.64597 2.04676 9.5111 2.10067 9.41167 2.19663C9.31223 2.29259 9.25637 2.42274 9.25637 2.55845C9.25637 2.69416 9.31223 2.82431 9.41167 2.92027C9.5111 3.01623 9.64597 3.07014 9.78659 3.07014C9.92721 3.07014 10.0621 3.01623 10.1615 2.92027C10.261 2.82431 10.3168 2.69416 10.3168 2.55845C10.3168 2.42274 10.261 2.29259 10.1615 2.19663C10.0621 2.10067 9.92721 2.04676 9.78659 2.04676Z",
		fill: "#979797"
	})]
});
const ForwardRef = forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
